import useResponsiveProp from "../../../hooks/useResponsiveProp";
import {
  JustifyContent,
  ResponsiveDimension,
  ResponsiveProp
} from "../../../types";
import Box from "../Box";
import { useColumnsContext } from "../Columns";
import { widths } from "./consts";
import { removePaddingFromVisuallyFirst } from "./utils";

export type Width = keyof typeof widths | "content" | null;

type Props = {
  children: React.ReactNode;
  width?: ResponsiveProp<Width>;
  alignX?: ResponsiveProp<JustifyContent>;
};

export default function Column({ children, width, alignX }: Props) {
  const {
    collapseOnMobile,
    collapseOnTablet,
    mobileSpace,
    tabletSpace,
    desktopSpace,
    reverseOnCollapse
  } = useColumnsContext();

  const responsiveWidth = useResponsiveProp(width);

  return (
    <Box
      display="flex"
      width={responsiveWidth === "content" ? undefined : "100%"}
      paddingLeft={
        [
          collapseOnMobile ? "none" : mobileSpace,
          collapseOnTablet ? "none" : tabletSpace,
          desktopSpace
        ] as ResponsiveDimension
      }
      paddingTop={
        [
          collapseOnMobile ? mobileSpace : "none",
          collapseOnTablet ? tabletSpace : "none",
          "none"
        ] as ResponsiveDimension
      }
      justifyContent={alignX}
      {...removePaddingFromVisuallyFirst({
        collapseOnMobile,
        collapseOnTablet,
        reverseOnCollapse
      })}
      flex={
        !responsiveWidth || responsiveWidth === "content"
          ? undefined
          : getSizeStyle(widths[responsiveWidth])
      }
    >
      {children}
    </Box>
  );
}

function getSizeStyle(scale: number) {
  return `0 0 ${scale * 100}%`;
}
